module.exports = __webpack_public_path__ + "img/isa1.229f5d25.png";